(function () {
  var bar = document.querySelector('[data-product-sticky-bar]');
  var gallery = document.querySelector('.product__media-wrapper');
  if (!bar || !gallery || !('IntersectionObserver' in window)) return;

  var footer = document.querySelector('.footer');
  var galleryVisible = true;
  var footerVisible = false;

  function updateVisibility() {
    bar.classList.toggle('is-visible', !galleryVisible && !footerVisible);
  }

  var galleryObserver = new IntersectionObserver(function (entries) {
    galleryVisible = entries[0].isIntersecting;
    updateVisibility();
  });
  galleryObserver.observe(gallery);

  if (footer) {
    var footerObserver = new IntersectionObserver(function (entries) {
      footerVisible = entries[0].isIntersecting;
      updateVisibility();
    });
    footerObserver.observe(footer);
  }
})();
